"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.main = void 0;
exports.main = function (axios) {
    return {
        // [Main]
        getMainMenus: function () {
            return axios.get('/menus');
        },
        getMenusFavorites: function () {
            return axios.get('/menus/favorites');
        },
        putMenusFavorites: function (_a) {
            var params = _a.params;
            return axios.put("/menus/favorites?menuNo=" + params.menuNo + (params.appNo ? "&appNo=" + params.appNo : ''));
        },
        putMenusFavoritesOrders: function (request) {
            return axios.put('/menus/favorites/orders', request.data);
        }
    };
};
